// Bahagi ng delivery-picker module set (dating monolitikong
// cart-delivery-picker.js, hinati by-responsibility 2026-08-24 — PURE
// REFACTOR, walang behavior change). Shared namespace ang pinag-uusapan ng
// mga file: window.FlowercartDeliveryPicker (DP).
//
// LOAD ORDER: ang file na ITO ang dapat maunang ma-load sa theme.liquid —
// dito ginagawa ang DP.CONFIG at DP.state na ina-alias ng ibang file sa
// script-execution time. Ang lahat ng cross-file na FUNCTION na tawag ay
// late-bound sa DP.* (tumatakbo lang sa/after DOMContentLoaded), kaya
// order-agnostic ang natitirang walong file.
//
// Saklaw ng file na ito: CONFIG defaults + schedule-rules fetch/apply
// (fetchScheduleRules, applyScheduleRules, refreshScheduleRules), pati ang
// shared mutable state, setupDayjs, at cacheElements.
(function () {
  const DP = (window.FlowercartDeliveryPicker = window.FlowercartDeliveryPicker || {});

  const RULES_ENDPOINT = "/apps/schedule-rules";
  const CONFIG = {
    timezone: "Asia/Manila",
    maxDays: 25,
    slots: [
      { display: "9AM-12PM", value: "9AM-12PM" },
      { display: "12PM-3PM", value: "12PM-3PM" },
      { display: "3PM-6PM", value: "3PM-6PM" },
      { display: "6PM-11PM", value: "6PM-11PM" }
    ]
  };

  let state = {
    isUpdating: false,
    pendingCartPayload: null,
    pendingTrigger: null,
    pendingUpdateResolves: [],
    fpInstance: null,
    elements: {},
    calendarEscapeHandler: null,
    countdownIntervalId: null,
    // Ang TANGING source of truth ng availability (Hakbang 3, 2026-09-02) —
    // {today, minDate, maxDate, cutoffAt, dates: {dateStr: {dateBlocked, slots}}}
    // mula sa /apps/schedule-rules. `null` hanggang sa unang successful fetch —
    // ang lahat ng DP.isDate*/isSlot* function ay dapat mag-fail-safe sa
    // "blocked/unavailable" kapag wala pa nito, kaya disabled/empty shell na
    // lang ang lumalabas bago dumating ang unang fetch (walang loading state).
    availability: null,
    // true lang kapag kumpirmadong nag-fail ang huling fetchScheduleRules() —
    // hindi ito "not yet loaded", kaya walang checkout block habang
    // tumatakbo pa ang normal (madalas <1s) na unang fetch sa mount().
    scheduleLoadFailed: false
  };

  function setupDayjs() {
    if (typeof dayjs === "undefined") return false;

    if (window.dayjs_plugin_utc && !dayjs.prototype.utc) {
      dayjs.extend(window.dayjs_plugin_utc);
    }
    if (window.dayjs_plugin_timezone && !dayjs.prototype.tz) {
      dayjs.extend(window.dayjs_plugin_timezone);
    }
    if (window.dayjs_plugin_customParseFormat && !dayjs.prototype.parseFormat) {
      dayjs.extend(window.dayjs_plugin_customParseFormat);
    }
    return true;
  }

  function cacheElements() {
    state.elements = {
      dateInput: document.getElementById("delivery-date"),
      dateStrip: document.getElementById("date-strip"),
      timeHidden: document.getElementById("delivery-time-hidden"),
      timeContainer: document.getElementById("time-slots-container"),
      errorDiv: document.getElementById("delivery-error"),
      cardMessageInput: document.getElementById("delivery-card-message"),
      cardMessageAttribute: document.getElementById("delivery-card-message-attribute"),
      calendarBtn: document.getElementById("open-full-calendar"),
      dateDisplay: document.getElementById("delivery-date-display"),
      monthYearMeta: document.getElementById("delivery-month-year"),
      countdown: document.getElementById("delivery-countdown"),
      countdownText: document.getElementById("delivery-countdown-text"),
      deliveryCard: document.querySelector("#main-cart-footer .delivery-card"),
      checkoutBtns: document.querySelectorAll('[name="checkout"], .cart__checkout-button'),
      dynamicCheckoutButtons: document.querySelector(".cart__dynamic-checkout-buttons")
    };
    return !!state.elements.dateInput;
  }

  // Dynamic/express checkout buttons (GCash/Maya/Shop Pay, Shopify-owned/iframed)
  // have no click-listener attach point — bindCheckoutValidation() can't guard
  // them the way it guards the plain Checkout button. CSS pointer-events is the
  // only reach we have into that wrapper while the schedule fetch has failed.
  function setDynamicCheckoutBlocked(isBlocked) {
    const { dynamicCheckoutButtons } = state.elements;
    if (!dynamicCheckoutButtons) return;
    dynamicCheckoutButtons.classList.toggle("is-schedule-blocked", isBlocked);
  }

  function isValidSlotEntry(slot) {
    return (
      !!slot &&
      typeof slot === "object" &&
      typeof slot.available === "boolean" &&
      typeof slot.blocked === "boolean" &&
      (slot.lastOrderAt === null || typeof slot.lastOrderAt === "string")
    );
  }

  function isValidDateEntry(entry) {
    if (!entry || typeof entry !== "object") return false;
    if (typeof entry.dateBlocked !== "boolean") return false;
    if (!entry.slots || typeof entry.slots !== "object") return false;

    return Object.keys(entry.slots).every((slotKey) => isValidSlotEntry(entry.slots[slotKey]));
  }

  // Hakbang 3 (2026-09-02): ang availabilityWindow na ito ang TANGING source
  // ng availability sa client — kaya kailangang mahigpit itong ma-validate
  // dito bago ito paniwalaan. Kulang o malformed na shape → return false, na
  // tumatama sa parehong Hakbang 1 fail-safe (scheduleLoadFailed + error UI +
  // checkout block) na ginawa noong 2026-09-02.
  function isValidAvailabilityWindow(availabilityWindow) {
    if (!availabilityWindow || typeof availabilityWindow !== "object") return false;

    const { today, minDate, maxDate, cutoffAt, dates } = availabilityWindow;

    if (typeof today !== "string" || !today) return false;
    if (typeof minDate !== "string" || !minDate) return false;
    if (typeof maxDate !== "string" || !maxDate) return false;
    if (typeof cutoffAt !== "string" || !cutoffAt) return false;
    if (!dates || typeof dates !== "object") return false;

    return Object.keys(dates).every((dateStr) => isValidDateEntry(dates[dateStr]));
  }

  function applyScheduleRules(rules) {
    if (!rules || typeof rules !== "object") return false;
    if (!isValidAvailabilityWindow(rules.availabilityWindow)) return false;

    // Display/formatting lang ito — hindi availability math, kaya hindi
    // saklaw ng validation sa itaas. Soft-apply: kapag wala o malformed,
    // panatilihin ang kasalukuyang CONFIG value.
    const nextSlots = Array.isArray(rules.slots)
      ? rules.slots
        .filter(
          (slot) =>
            slot &&
            typeof slot.display === "string" &&
            slot.display &&
            typeof slot.value === "string" &&
            slot.value
        )
        .map((slot) => ({
          display: slot.display,
          value: slot.value
        }))
      : [];

    if (typeof rules.timezone === "string" && rules.timezone) {
      CONFIG.timezone = rules.timezone;
    }

    if (nextSlots.length) {
      CONFIG.slots = nextSlots;
    }

    state.availability = rules.availabilityWindow;

    return true;
  }

  const RULES_RETRY_DELAYS_MS = [500, 1500];

  function takePrefetchedRules() {
    const pending = window.FlowercartRulesPrefetch;
    window.FlowercartRulesPrefetch = null;
    return pending;
  }

  async function fetchScheduleRulesOnce() {
    try {
      const response = (await takePrefetchedRules()) || (await fetch(RULES_ENDPOINT, {
        headers: {
          "Accept": "application/json"
        }
      }));

      if (!response.ok) {
        throw new Error(`Rules request failed with status ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.warn("Delivery rules fetch failed:", error);
      return null;
    }
  }

  async function fetchScheduleRules() {
    for (let attempt = 0; ; attempt++) {
      const rules = await fetchScheduleRulesOnce();
      if (rules || attempt >= RULES_RETRY_DELAYS_MS.length) return rules;
      await new Promise((resolve) => setTimeout(resolve, RULES_RETRY_DELAYS_MS[attempt]));
    }
  }

  const FALLBACK_RULES = { cutoffHour: 17, prepHours: 1 };

  function parseSlotStartMinutes(slotValue) {
    const match = /^\s*(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i.exec(slotValue);
    if (!match) return null;
    const hour = (Number(match[1]) % 12) + (match[3].toUpperCase() === "PM" ? 12 : 0);
    return hour * 60 + (match[2] ? Number(match[2]) : 0);
  }

  // Mirrors delivery-scheduler's DEFAULT_DELIVERY_SCHEDULE_RULES window math.
  // Blind to merchant-blocked dates and slot capacity — those live only server-side.
  function buildLocalAvailabilityWindow() {
    const tz = CONFIG.timezone;
    const dayStart = (dateStr) => dayjs.tz(dateStr, "YYYY-MM-DD", tz);
    const now = dayjs().tz(tz);
    const today = now.format("YYYY-MM-DD");
    const cutoffAt = dayStart(today).add(FALLBACK_RULES.cutoffHour, "hour");
    const minDate = now.isBefore(cutoffAt) ? today : dayStart(today).add(1, "day").format("YYYY-MM-DD");
    const maxDate = dayStart(minDate).add(CONFIG.maxDays - 1, "day").format("YYYY-MM-DD");

    const dates = {};
    for (let day = dayStart(minDate); day.format("YYYY-MM-DD") <= maxDate; day = day.add(1, "day")) {
      const slots = {};
      CONFIG.slots.forEach((slot) => {
        const startMinutes = parseSlotStartMinutes(slot.value);
        if (startMinutes === null) return;
        const lastOrderAt = day.add(startMinutes - FALLBACK_RULES.prepHours * 60, "minute");
        slots[slot.value] = {
          available: Date.now() < lastOrderAt.valueOf(),
          blocked: false,
          lastOrderAt: lastOrderAt.toISOString()
        };
      });
      dates[day.format("YYYY-MM-DD")] = { dateBlocked: false, slots };
    }

    return { today, minDate, maxDate, cutoffAt: cutoffAt.toISOString(), dates };
  }

  function applyLocalFallback() {
    try {
      const availabilityWindow = buildLocalAvailabilityWindow();
      if (!isValidAvailabilityWindow(availabilityWindow)) return false;
      state.availability = availabilityWindow;
      console.warn("Delivery rules: using local fallback schedule");
      return true;
    } catch (error) {
      console.warn("Delivery rules local fallback failed:", error);
      return false;
    }
  }

  async function runScheduleRulesRefresh() {
    const rules = await fetchScheduleRules();
    const applied = (rules && applyScheduleRules(rules)) || applyLocalFallback();
    if (!applied) {
      state.scheduleLoadFailed = true;
      DP.setDynamicCheckoutBlocked(true);
      DP.showScheduleLoadError();
      return false;
    }

    if (state.scheduleLoadFailed) {
      state.scheduleLoadFailed = false;
      DP.setDynamicCheckoutBlocked(false);
      DP.toggleError(null);
    }

    DP.initFlatpickr();

    const scheduleChanged = DP.sanitizeSelectedSchedule();
    DP.preselectDefaultDate();

    const dateValue = state.elements.dateInput ? state.elements.dateInput.value : null;

    DP.renderDateStrip();
    DP.renderTimeSlots(dateValue, true);
    DP.renderCountdown();

    if (scheduleChanged) {
      void DP.updateCart(DP.buildCartPayload(), "rules-refresh");
    }

    return true;
  }

  let inflightRefresh = null;

  function refreshScheduleRules() {
    if (!inflightRefresh) {
      inflightRefresh = runScheduleRulesRefresh().finally(() => {
        inflightRefresh = null;
      });
    }
    return inflightRefresh;
  }

  DP.CONFIG = CONFIG;
  DP.state = state;
  DP.setupDayjs = setupDayjs;
  DP.cacheElements = cacheElements;
  DP.setDynamicCheckoutBlocked = setDynamicCheckoutBlocked;
  DP.refreshScheduleRules = refreshScheduleRules;
})();
